import './style.scss';
import { TranslationService } from '../../../services/translation.service';
import timesCircle from '../../../../assets/icons/times-circle-blue-1000.svg';
import DataUrlHelper from '../../../helpers/data-url.helper';

function SelectedFilterValue({ ariaLabel = '', id, className, children, onRemove }: { ariaLabel?: string; id: string; className?: string; children: React.ReactNode; onRemove: (id: string) => void }) {
  function handleRemove() {
    onRemove(id);
  }

  return (
    <button
      type="button"
      aria-label={`${TranslationService.get('common.removefilter')}: ${ariaLabel}`}
      className={`selected-filter-value mb-1 me-2 border d-flex flex-nowrap justify-content-between align-items-center rounded position-relative ${className ?? ''}`}
      onClick={handleRemove}
    >
      {children}
      <span className="selected-filter-value__close rounded-circle position-absolute d-flex justify-content-center align-items-center">
        <img src={DataUrlHelper.encode(timesCircle)} alt="" className="selected-filter-value__close_icon" />
      </span>
    </button>
  );
}

export default SelectedFilterValue;
